<template>
  <div class="main-frame">
    <el-container>
      <!-- 动态表头 -->
      <el-header class="banner-head" height="60px">
        <div class="head-info">
          <FormComponent
            :form-fields="pageConfig.formFields"
            :params="params"
            :parent-ctx="parentCtx"
            @update:params="handleParamsUpdate"
            @search="search"
          />
        </div>
      </el-header>

      <!-- 动态表格 -->
      <el-main ref="tableWrapper" style="padding-top: 10px">
        <TableComponent
          :table-columns="pageConfig.tableColumns"
          :list="formattedList"
          :loading="loading"
          :table-height="tableHeight"
          :parent-ctx="parentCtx"
        />
      </el-main>

      <!-- 分页 -->
      <el-footer class="footer-info">
        <el-pagination
          style="margin-top: 15px"
          background
          :page-sizes="pageSizes"
          :page-size="page.page_size"
          :total="totalCount"
          :current-page="page.page_number"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import baseSearch from "@/mixins/baseSearch.js";
import { pageConfigs } from "@/views/banner/config/pageConfigs";
import FormComponent from "@/components/Dynamic/FormComponent.vue";
import TableComponent from "@/components/Dynamic/TableComponent.vue";
import { GetCacheKey } from "@/const";

export default {
  name: "BannerAspectRatioListView",
  components: { FormComponent, TableComponent },
  mixins: [baseSearch],
  data() {
    return {
      list: [],
      pageConfig: pageConfigs.bannerAspectRatioList,
      params: {
        platform: null,
        status: 0,
        key: "",
      },
      parentCtx: {},
      cacheKey: GetCacheKey("banner"),
    };
  },
  computed: {
    // 添加计算属性来格式化列表数据
    formattedList() {
      return this.list.map((item) => {
        return {
          ...item,
          platform: this.formatPlatform(item.platform),
        };
      });
    },
  },
  created() {
    this.parentCtx = {
      search: (params) => this.search(params),
      editModel: (model) => this.editModel(model),
      removeModel: (model) => this.removeModel(model),
      createModel: () => this.createModel(),
      formatTimeRange: (time) => this.formatTimeRange(time),
      formatPlatform: (platform) => this.formatPlatform(platform), // 传递格式化方法
    };
  },
  mounted() {
    this.getList();
  },
  beforeDestroy() {
    this.parentCtx = null;
  },
  methods: {
    // 添加平台格式化方法
    formatPlatform(platform) {
      const platformMap = {
        1: "PC",
        2: "WAP",
      };
      return platformMap[platform] || platform;
    },

    async getList() {
      try {
        this.loading = true;
        const res = await this.$common.httpPost(this.pageConfig.apiPath, {
          ...this.fetchParams,
          ...this.page,
        });

        if (res.code === "1000000") {
          this.list = res.data.array || [];
          this.totalCount = res.data.total;
        } else {
          this.$message.error(res.message || "获取数据失败");
        }
      } catch (error) {
        this.$message.error(error || "获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    createModel() {
      this.$router.push("banner-aspect-ratio-detail");
    },

    editModel(model) {
      this.$router.push("banner-aspect-ratio-detail?id=" + model.id);
    },

    async removeModel(model) {
      try {
        await this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        this.loading = true;
        const res = await this.$common.httpPost(
          "/api/banner/admin/aspect_ratio/delete",
          {
            id: model.id,
          }
        );

        if (res.code === "1000000") {
          this.$message.success("删除成功");
          this.$common.removeGlobalStorage(this.cacheKey.aspectRatioList);
        } else {
          this.$message.error(res.message || "获取数据失败");
        }

        this.getList();
      } catch (error) {
        if (typeof error === "string" && error.includes("cancel")) {
          // console.log('用户取消删除');
        } else {
          this.$message.error(error || "获取数据失败");
        }
      } finally {
        this.loading = false;
      }
    },
    handleParamsUpdate(formData) {
      this.params = {
        ...this.params,
        ...formData,
      };
    },
  },
};
</script>

<style scoped>
::v-deep .el-link.el-link--primary {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

::v-deep .el-table__row {
  font-size: 13px;
}

::v-deep .el-table th {
  background-color: #f5f7fa !important;
}
</style>